import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { SharedModule } from '@shared/shared.module';
import {
  AlertTriangle,
  Check,
  ClipboardList,
  Edit2,
  Globe,
  GraduationCap,
  Loader2,
  Plus,
  Trash2,
  X
} from 'lucide-angular';
import { ModalShellComponent } from '@infrastructure/ui/components/modals/modal-shell/modal-shell.component';
import { TabsComponent } from '@infrastructure/ui/components/tabs/tabs.component';
import { TabPanelComponent } from '@infrastructure/ui/components/tabs/tab-panel.component';
import { FormFooterComponent } from '@infrastructure/ui/components/forms/form-footer/form-footer.component';
import { PrototypeSelectComponent } from '@infrastructure/ui/components/forms/prototype-select/prototype-select.component';
import { PeriodoSelectComponent } from '@infrastructure/ui/components/forms/periodo-select/periodo-select.component';
import { AnexosComponent } from '@infrastructure/ui/components/anexos/anexos.component';
import { DatepickerComponent } from '@infrastructure/ui/components/forms/datepicker/datepicker.component';
import { PageTitleModule } from '@infrastructure/ui/components/page-title/page-title.module';
import { UtilsComponentesModule } from '../../../utils/componentes/utils-componentes.module';
import { InstrumentosAvaliacaoComponent } from './instrumentos-avaliacao.component';
import { InstrumentoAvaliacaoModalModule } from './instrumento-avaliacao-modal.module';

@NgModule({
  declarations: [
    InstrumentosAvaliacaoComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ModalShellComponent,
    TabsComponent,
    TabPanelComponent,
    FormFooterComponent,
    PrototypeSelectComponent,
    PeriodoSelectComponent,
    PageTitleModule,
    AnexosComponent,
    DatepickerComponent,
    UtilsComponentesModule,
    InstrumentoAvaliacaoModalModule,
    LucideAngularModule.pick({
      AlertTriangle,
      Check,
      ClipboardList,
      Edit2,
      Globe,
      GraduationCap,
      Loader2,
      Plus,
      Trash2,
      X
    }),
    SharedModule
  ],
  exports: [
    InstrumentosAvaliacaoComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class InstrumentosAvaliacaoModule { }
